import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalTaxDeleteProps {}

const ModalTaxDelete = ({}: ModalTaxDeleteProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    invoice: { setInvoice },
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.deleteTaxes');
  const onClose = () => {
    closeSingleModal('deleteTaxes');
    setInvoice('selected.tax', -1);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Remover taxa"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Tax.Delete />
    </Modal>
  );
};

export default ModalTaxDelete;
